import React, { Component } from 'react';


class AksharDeploy extends Component {
    constructor() {
        super();
    }

    routeToReferenceDoc = () => {
        window.open("https://github.com/DheeYantra/dhee-online-transcription-api-js", "_blank")
    }

    render() {
        return (
            <div>
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <div className="wrapper" style={{ height: "430px" }}>
                    <div className="row">
                        <div className="col-12">
                            {/* Custom Tabs */}
                            <h6 className="nav-item" style={{
                                color: '#282a65',
                                marginTop: '10px', marginLeft: '20px'
                            }}>Deploy</h6>

                            <div className="card-body p-0 mb-25" style={{ marginLeft: "20px" }}>
                                <div className="tab-content col-12 p-0">
                                    <div className="tab-pane active show" id="tab_1">
                                        <div className="card card-primary mt-3">
                                            <div className="card-body raise-form">
                                                <div className="col-sm-12">
                                                    <div className="col-sm-7">
                                                        <div style={{ width: 'auto' }}>
                                                            <div style={{
                                                                marginTop: '10px', marginLeft: '20px', color: '#282a65',
                                                            }}>For Akshar Api usage you will be charged 10 paise per API call
                                                            </div>
                                                            <div style={{
                                                                marginTop: '10px', marginLeft: '20px', color: '#282a65',
                                                            }}>Please deploy from <a href={window.origin + "/platform/projectmgmt/test-and-deploy/DistributionWidget"}>Unified Project Launchpad</a>
                                                            </div>
                                                            <div style={{ marginTop: '20px', marginLeft: '20px' }}>
                                                                <h4>Note:</h4>
                                                                <div style={{ lineHeight: '2', marginTop: '-7px', color: '#282a65' }}>
                                                                    {/* Please give 5 minutes from the deployment time for the voice bots to sync up with new voice models.<br /> */}
                                                                    To integrate transliteration to your application please follow below information.


                                                                    {/* ============HTML PAGE INTEGRATION=================== */}
<br/>
<br/>
                                                                    <h1>Dhee.AI Transliteration REST API</h1>

                                                                    The transliteration API of Dhee.AI helps you to change the script of an input text to a different one. This is ideal for reading names, addresses, etc in a desired language, in spite of the source text being in a different language (or script, to be particular).


                                                                    The API is to be used via REST calls, as per the specifications below:
                                                               <br/>     <br/><h2>Request Format</h2><br/>
                                                                    <table width="100%" border="1">
                                                                        <tr>
                                                                            <td>URL</td>
                                                                            <td>https://runtime.dhee.ai/akshar/<span>&#10100;</span>projectId<span>&#10101;</span>/transcribe</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>METHOD</td>
                                                                            <td >POST</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Authentication</td>
                                                                            <td>Basic, with apiKey & secret</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Parameters</td>
                                                                            <td>text, targetLanguage, entityType

text : The text to be transcribed.

targetLanguage : language to which text should be transcribed

entityType : The type of the text. Possible values are NAME, ADDRESS, OTHERS</td>
                                                                        </tr>
                                                                    </table>
<br/>
<h2>Request Headers</h2><br/>



<table width="100%" border="1">
                                                                        <tr>
                                                                            <td>Content-Type

</td>
                                                                            <td>application/x-www-form-urlencoded

</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>authorization</td>
                                                                            <td >POST</td>
                                                                        </tr>
                                                                        
                                                                    </table>





                                                               <br/>   <h2>  Response Format</h2>
The output response body will be a JSON of the following format -
<br/>

<span>&#10100;</span>
<br/>


        result:"<span>&#10100;</span>
        transliterated text<span>&#10101;</span>
        OR <span>&#10100;</span>
        error message in case success=false<span>&#10101;</span>
        ",
<br/>
        success : “true|false”
        <br/>

<span>&#10101;</span>
































                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default AksharDeploy


// WEBPACK FOOTER //
// ./src/aksharUi/AksharDeploy.js